const SCORE_FIELDS = [
  { key: 'attendance', label: '参与度' },
  { key: 'pronunciation', label: '发音' },
  { key: 'comprehension', label: '理解力' },
  { key: 'fluency', label: '流畅度' },
  { key: 'creativity', label: '创造力' }
]

function scoreRows (grade) {
  if (!grade) return []
  const rows = SCORE_FIELDS.map(field => ({
    key: field.key,
    label: field.label,
    value: Number(grade[field.key]) || 0,
    lowest: false
  }))
  const minimum = Math.min.apply(null, rows.map(row => row.value))
  return rows.map(row => Object.assign({}, row, { lowest: row.value === minimum }))
}

module.exports = { scoreRows }
